import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
  history: createWebHistory(),
  base: process.env.BASE_URL,
  routes: [
    /* your routes here */
  ],
});

export default router;